import { FC } from "react";
import { useAppSelector } from "../store";
import { isPermitted } from "../helpers/permissions/featurePermission";
import { pageError } from "../routes/error";
import { PagesEnum } from "@vviinn/user-managment-client-ts";

type RestrictedProps = {
  permissions?: string;
  requiredPagesPermission?: PagesEnum;
  showError?: boolean;
  fallback?: React.ReactNode;
};

export const Restricted: FC<React.PropsWithChildren<RestrictedProps>> = ({
  permissions,
  requiredPagesPermission,
  children,
  showError = false,
  fallback,
}) => {
  const actualPermissions = useAppSelector(
    (state) => state.company.company?.featurePermissions,
  );
  const allowedPages = useAppSelector((state) => state.pages.pages);
  const returnOnLoading = showError ? pageError("403") : null;
  // fallback is for a real denial only — not while permissions are still loading.
  const returnOnNonPermitted = fallback ?? returnOnLoading;
  if (actualPermissions === undefined || allowedPages === undefined)
    return returnOnLoading;
  return (permissions === undefined ||
    isPermitted(actualPermissions, permissions)) &&
    (requiredPagesPermission === undefined ||
      allowedPages.includes(requiredPagesPermission)) ? (
    <>{children}</>
  ) : (
    returnOnNonPermitted
  );
};
